var map = {
	"./AngryPressed.png": 77546,
	"./Apotek.png": 66739,
	"./DownImg.png": 84204,
	"./FlagFinland.png": 36047,
	"./FlagLatvia.png": 17926,
	"./FlagNorway.png": 84857,
	"./FlagSlovenian.png": 82950,
	"./FlagSweden.png": 69759,
	"./HappyPressed.png": 25409,
	"./OkPressed.png": 84817
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85994;